import moment from 'moment'
import { userRoleDict } from '../../config'

export const getHideCustomerIdSearch = () => {
	if (localStorage.userInfo) {
		const userInfo = JSON.parse(localStorage.userInfo)
		if (userInfo.customerLevel == '1' && (userInfo.userRoleId === userRoleDict.admin || userInfo.userRoleId === userRoleDict.operate)) {
			return false
		} else {
			return true
		}
	} else {
		return true
	}
}

export const renderList = [
	{
		label: '开始日期',
		key: 'startCreateDate',
		type: 'datePicker',
		placeholder: '请选择',
	},
	{
		label: '结束日期',
		key: 'endCreateDate',
		type: 'datePicker',
		placeholder: '请选择',
	},
	{
		label: '广告位名称',
		key: 'adPosName',
		type: 'input',
		placeholder: '请输入'
	}
]

export const renderMobileList = [
	{
		label: '选择日期',
		key: 'dates',
		type: 'rangePicker',
		placeholder: '请选择',
		maxInterval: 31,
		maxEndDate: new Date(moment(new Date()).format('YYYY-MM-DD')),
        minStartDate: new Date(moment(new Date()).subtract(2, 'year').format('YYYY-MM-DD'))
	},
	{
		label: '账户ID',
		key: 'advertiseId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '客户',
		key: 'customerId',
		type: 'picker',
		placeholder: '请选择',
		isRowEnd: true,
		isHide: true,
		options: [],
		valueKey: 'label',
	}
]


// WEBPACK FOOTER //
// ./src/pages/home/dataEffect/dataReport/config.js